/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

export default {
    SET_USERS (state, income) {
        const usersList = [],
            teams = income.data.result
        teams.forEach(function (val) {
            const teamName = val.name

            // Users
            val.users.forEach(function (val) {
                const user = val
                user['role'] = val.roles.name
                user['team'] = teamName
                usersList.push(val)
            })
        })
        console.log(usersList)
        state.users = usersList
    },
    REMOVE_RECORD (state, itemId) {
        const userIndex = state.users.findIndex((u) => u.id === itemId)
        state.users.splice(userIndex, 1)
    }
}
